// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"d8e719ae","498":"73ddc47f","598":"f2451d72"}[chunkId] + ".chunk.js";
};